import React, { useState } from 'react'
import Styles from './dashboard.module.css'
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import { Outlet } from 'react-router-dom'
function Dashboard() {
    const [isSidebar, setIsSideBar] = useState(true)
    const toggleSideBar = () => {
        setIsSideBar(!isSidebar);
    }

    return (
        <div className={Styles.body}>
            <div className={Styles.content}>
                {!isSidebar ? <Sidebar  isSidebar={isSidebar} toggleSideBar={toggleSideBar}/> : ""}
                <div className={!isSidebar ? Styles.right_side : Styles.right_side_full}>
                    <Header isSidebar={isSidebar} toggleSideBar={toggleSideBar} />
                    <Outlet />
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Dashboard